export default "__VITE_ASSET__ab82d350__"